import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Onedrive = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.429 9.847a4.47 4.47 0 017.573-2.012 4.186 4.186 0 011.136-.21v-.13c0-2.482-1.845-4.495-4.12-4.495-1.626 0-3.02 1.038-3.69 2.531a3.01 3.01 0 00-1.694-.535c-1.785 0-3.231 1.577-3.231 3.523 0 .21.024.414.057.613-1.377.136-2.455 1.544-2.455 3.08 0 .016.004.029.004.045-.001.014-.009.028-.009.042 0 .615.214 1.177.561 1.631A2.638 2.638 0 002.701 15h1.261a3.574 3.574 0 01-.398-1.615 3.62 3.62 0 012.865-3.538zm11.46 1.93c-.025 0-.05.007-.075.008.007-.074.022-.146.022-.222a2.664 2.664 0 00-2.665-2.664 2.64 2.64 0 00-1.564.516 3.22 3.22 0 00-2.838-1.712 3.237 3.237 0 00-3.237 3.237c0 .023.006.043.007.066a2.36 2.36 0 00-.359-.036 2.414 2.414 0 00-2.366 2.902A2.612 2.612 0 007.38 16h10.706v-.019a2.106 2.106 0 00-.197-4.204z"
  }));
});
Onedrive.displayName = 'Onedrive';
export var OnedriveDimensions = {
  height: 20,
  width: 20
};